import {verifiedFetch} from '@github-ui/verified-fetch'

const PULLS_PREFERENCES_PATH = '/pulls/preferences'

/**
 * The pulls dashboard preferences that can be persisted server-side, keyed by
 * the external (API) names accepted by `PUT /pulls/preferences`. List-valued
 * preferences are sent as comma-separated strings; an empty value clears the
 * stored preference.
 */
export interface PullsDashboardPreferences {
  default_view: string
  max_pr_age: string
  compact_mode: boolean
  inbox_options_tip_dismissed: boolean
  collapsed_sections: string[]
  section_order: string[]
  hidden_sections: string[]
  selected_repos: string[]
}

function toFormData(partial: Partial<PullsDashboardPreferences>): FormData {
  const formData = new FormData()
  for (const [key, value] of Object.entries(partial)) {
    formData.set(key, Array.isArray(value) ? value.join(',') : String(value))
  }
  return formData
}

/**
 * Fire-and-forget write of a partial set of pulls dashboard preferences to the
 * server so they survive cookies being cleared. Cookies remain the source of
 * truth for reads, so failures here are intentionally swallowed.
 */
export function persistPullsPreferences(partial: Partial<PullsDashboardPreferences>): void {
  void writePreferences(partial)
}

async function writePreferences(partial: Partial<PullsDashboardPreferences>): Promise<void> {
  try {
    await verifiedFetch(PULLS_PREFERENCES_PATH, {method: 'PUT', body: toFormData(partial)})
  } catch {
    // Durable backup only; the cookie write already succeeded.
  }
}
